import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { CSSTransition } from 'react-transition-group';
import Link from 'valuelink';
import { Input } from 'valuelink/lib/tags';
import { FaTimes } from 'react-icons/fa';
import { Player } from '@lottiefiles/react-lottie-player';

import {
  searchOnlineDoctors,
  defaultIssueSearch,
  autoSuggest,
  fetchSlots,
  getMajorConcernIssues,
  logHealthConcernIssues,
  getAllDopeRelatives,
} from '../../../services/';
import clientConfig from '../../../clientConfig';
import LoadingComponent from '../../../components/common/LoadingComponent';
import StyledTappable from '../../../components/common/StyledTappable';
import { ButtonText, RegularText, Text } from '../../../components/common/Text';
import { PrimaryButton } from '../../../components/common/Buttons';
import Modal from '../../common/Modal';
import {
  FlyInTransition,
  FadeTransition,
} from '../../../components/transitions/transitions';
import { setPlaceholderImageForNode, debounce, fontSize } from '../../../utils';
import { logEvent } from '../../../utils/logEvent';
import DoctorSelectCardNew from '../../../components/consultations/DoctorSelectCardNew';
import DoctorProfileNew from '../../consultation/DoctorProfileNew';
import { setSearchText } from '../../../actions';
import CalendarModal from '../../../components/consultations/CalendarModal';
import DoctorFilterModal from '../../../components/consultations/DoctorFilterModal';

import PatientModal from '../../../components/common/PatientModal';
import { SERVICE_LINE_NAMES } from '../../../config';
import { LocationFetcherWrapper } from '../../../utils/nativeGeolocation';

import errorModalBg from '../../../images/common/error-modal-bg.svg';
import Header from '../../../components/common/Header';
import errorModalIcon from '../../../images/common/error-modal.svg';
import crossIcon from '../../../images/cross_icon.svg';
import slotIcon from '../../../images/lab-test/slot.svg';
import morningIcon from '../../../images/lab-test/morning.svg';
import afternoonIcon from '../../../images/lab-test/afternoon.svg';
import eveningIcon from '../../../images/lab-test/evening.svg';
import slotSelected from '../../../images/lab-test/tick.svg';
import filterIcon from '../../../images/vaccination/FilterImg.svg';

const OuterContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: stretch;
  background: white;
  overflow: hidden;
`;

const HeaderContainer = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: stretch;
  background: white;
  z-index: 10;
  border: 1px solid #f0f3f6;
`;

const SearchContainer = styled.div`
  display: flex;
  margin: 20px;
  width: 100%;
  gap: 20px;
  padding: 0 20px;
  padding-bottom: 20px;
  margin-top: 10px;
  margin: auto;

  &.expand-enter.expand-enter-active {
    background: white;
    transition: 100ms linear;
  }
  &.expand-enter-done {
    background: white;
  }
  &.expand-exit {
    background: white;
  }
  &.expand-exit.expand-exit-active {
    background: none;
    transition: 100ms linear;
  }
`;

const SearchBoxContainer = styled.div`
  display: flex;
  align-self: stretch;
  align-items: center;
  border-radius: 12px;
  padding: 12px;
  height: 44px;
  max-width: 400px;
  flex: 1;
  background-color: #f0f3f6;
`;

const StyledInputBox = styled(Input)`
  flex: 1;
  background-color: #f0f3f6;
  margin-left: 1rem;

  &::placeholder {
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    color: #585969;
  }
`;

const CrossIconContainer = styled(StyledTappable)`
  padding: 5px;
`;

const BodyContainer = styled.div`
  flex: 1;
  display: flex;
  position: relative;
  flex-direction: column;
  background-color: white;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
`;

const SearchBodyContainer = styled.div`
  position: absolute;
  background: white;
  padding: 10px 0px;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  opacity: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
`;

const SearchResultText = styled(Text)`
  font-size: ${() => fontSize(1)};
  margin: 8px 10px;
  color: #7f7f7f;
`;

const IssueGroupContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  align-items: flex-start;
  background: white;
  margin-top: 6px;
`;

const ConcernText = styled.p`
  background: #e7e1ff;
  border-radius: 8px;
  padding: 10px 20px;
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
  color: rgba(88, 89, 105, 1);
`;

const IssueIcon = styled.img`
  width: 44px;
  height: 44px;
  margin-right: 14px;
`;

const SuggestionIcon = styled(IssueIcon)`
  width: 40px;
  height: 40px;
  border-radius: 18px;
`;

const IssueSuggestionIcon = styled(IssueIcon)`
  width: 40px;
  height: 40px;
  border-radius: 10px;
`;

const IssueContainer = styled(StyledTappable)`
  display: flex;
  flex-shrink: 0;
  justify-content: flex-start;
  align-self: stretch;
  padding: 20px;
  min-height: 46px;
  background: white;
  border-bottom: 1px solid #f0f3f6;
`;

const SubIssueContainer = styled(StyledTappable)`
  display: flex;
  flex-shrink: 0;
  justify-content: flex-start;
  align-self: stretch;
  padding: 12px 20px;
  min-height: 46px;
  background: white;
`;

const IssueTitleContainer = styled(StyledTappable)`
  display: flex;
  flex-shrink: 0;
  justify-content: flex-start;
  align-self: stretch;
  padding: 12px 20px;
  min-height: 90px;
  background: transparent;
`;

const IssueTitle = styled.div`
  background: rgba(var(--primary-button-rgb, 113, 79, 255), 1);
  min-height: 90px;
  padding: 15px;
  display: flex;
  width: 100%;
  flex-direction: row;
  border-radius: 15px;
`;

const IssueIconLarge = styled.img`
  height: 60px;
  width: 60px;
  background: #fff;
  border-radius: 15px;
  padding: 10px;
`;

const IssueData = styled.div`
  display: flex;
  flex-direction: column;
  color: #fff;
  margin-left: 15px;
  font-size: 12.5px;
`;

const SubIssueTile = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  min-height: 46%;
  justify-content: space-between;
  padding: 20px;
  box-shadow: 0px 4.77612px 19.1045px
    rgba(var(--primary-button-rgb, 113, 79, 255), 0.15);
  border-radius: 19.1045px;
`;

const SubIssueTextArea = styled.textarea`
  margin: 5px 20px;
  display: flex;
  flex-shrink: 0;
  align-self: stretch;
  padding: 10px;
  width: calc(100% - 40px);
  box-shadow: 0px 4.77612px 19.1045px
    rgba(var(--primary-button-rgb, 113, 79, 255), 0.15);
  border-radius: 10px;
`;

const PrimaryButtonPadded = styled(PrimaryButton)`
  margin: 5px 20px;
  width: calc(100% - 40px);
  display: flex;
  flex-shrink: 0;
  align-self: stretch;
  align-items: center;
  justify-content: center;
`;

const SubIssueCheckbox = styled.input`
  height: 17.5px;
  width: 17.5px;
`;

const IssueTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  justify-content: center;
`;

const SearchText = styled(RegularText)`
  font-size: ${() => fontSize(1)};
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 8px;
`;

const IssueSubText = styled(RegularText)`
  font-size: ${() => fontSize(0.75)};
  margin-bottom: 9px;
  color: #808080;
  font-weight: 500;
`;

const DoctorsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  background-color: white;
  overflow-y: auto;
`;
const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: white;
  overflow: hidden;
  height: 100%;
  width: 100vw;
  background: rgba(0, 0, 0, 0.5);
`;

const EmptyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0 2rem;
  flex: 1;
  flex-shrink: 0;
`;

const EmptyIcon = styled.img`
  width: 10rem;
  margin-bottom: 1.25rem;
`;

const EmptyText = styled(RegularText)`
  font-size: 1rem;
`;
const FilterButton = styled(PrimaryButton)`
  background-color: #ffffff;
  padding: 5px;
  border-radius: 8px;
  position: relative;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
const CloseContainer = styled(StyledTappable)`
  width: 1.625rem;
  height: 1.625rem;
  border-radius: 8px;
  border: 1px solid #eee;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CloseIcon = styled(FaTimes)`
  color: #413958;
`;
const RedDot = styled.div`
  height: 5px;
  width: 5px;
  position: absolute;
  top: 6px;
  right: 6px;
  border-radius: 50%;
  background: #fe4f1a;
`;
const DEFAULT_USER_CONCERN_DATA = {
  showConcern: false,
  concernHeading: '',
  issuesData: [],
  subIssuesData: [],
  selectedVerticalId: '',
  selectedIssue: {},
  selectedIssueId: '',
  selectedSubIssueId: [],
  otherDescription: '',
  currentStep: 0,
  otherInputId: '',
  isSubmitting: false,
  concernRecorded: false,
  selectedVerticalData: {},
  issueDoctorCount: '',
};

class DoctorListContainer extends Component {
  constructor(props) {
    super(props);
    this.fetchLocation = this.fetchLocation.bind(this);
    this.state = {
      doctors: [],
      onlineDoctors: [],
      offlineDoctors: [],
      opdLabel: '',
      bookingLabel: '',
      loading: true,
      requestLoading: false,
      profileVisible: false,
      openProfileId: null,
      assistantProfile: false,
      profileModalVisible: false,
      modalVisible: false,
      showSearchOverlay: false,
      relations: [],
      verticals: [],

      relativesSelectionVisible: false,
      searchText: '',
      newRelation: {
        adding: false,
        relationId: null,
        relationName: '',
        relationDob: '',
        relationAge: '',
        relationPhone: '',
        consentGiven: false,
      },
      selectedRelative: {
        relativeId: -1,
        relativeRelation: null,
        relativeIcon: null,
      },
      defaultIssues: [],
      selectedIssues: [],
      selectedVertical: null,
      searchResults: [],
      searching: false,
      showVerticalsLeftScroll: false,
      showVerticalsRightScroll: true,
      defaultConfig: [],
      verticalName: '',
      slots: [],
      labsFlow: '',
      labOrderId: '',
      showSearch: true,
      labsVerticalSelected: false,
      nextKey: '',
      scrollTopPos: '',
      paginatedCall: false,
      fetchNext: false,
      nextLoading: false,
      userConcernData: DEFAULT_USER_CONCERN_DATA,
      filterModal: false,
      showCalendar: false,
      showSlots: false,
      appointmentDetails: { date: '', time: '' },
      filterPresent: false,
      filters: {
        language: [],
        gender: null,
        availability: null,
      },
      disclaimersAndCheckboxes: [],
      disclaimerMessage: '',
      activeSlotType: 1,
      morningSlot: [],
      afternoonSlot: [],
      eveningSlot: [],
      currentLat: -1,
      currentLong: -1,
    };

    const { state } = props.location;
    //this.state.searchText = this.props.searchText;

    if (state) {
      this.consultRequestInfo = state;
      this.state.showVerticals = state.showVerticals;
      this.state.relativeId = state.relativeId;
      if (clientConfig.useDopeRelatives)
        if (state.relativeId && state.relativeId !== -1) {
          sessionStorage.setItem('consultRelativeId', state.relativeId);
        }
      this.state.selectedVertical = state.verticalId;
      this.state.showSearch = state.showSearch;
      if (state.labOrderId) this.state.labOrderId = state.labOrderId;
      if (state.labPatientName) {
        this.state.selectedRelative = {
          name: state.labPatientName,
          relativeRelation: 'Self',
        };
        this.doctorToBook = true;
      }
      if (state.labsFlow) this.state.labsFlow = state.labsFlow;
      if (state.labsSelectedVertical)
        this.state.labsVerticalSelected = state.labsSelectedVertical;
      if (state.searchText) this.state.searchText = state.searchText;
      if (state.showSearchOverlay)
        this.state.showSearchOverlay = state.showSearchOverlay;
      if (state.backToHome) this.state.backToHome = true;
    }
    this.debounceSearch = debounce((val) => this.searchIssues(val), 500);
    this.verticalScrollContainerRef = React.createRef();
    this.listContainerRef = React.createRef();
  }

  componentDidMount() {
    logEvent('Online Consultations Doctor List Page', {
      pageId: 1,
    });
    if (this.state.selectedVertical) {
      this.getAssistants({ v: this.state.selectedVertical });
    } else if (this.state.labsFlow) {
      this.getAssistants({ sf: this.state.labsFlow });
    } else {
      this.getAssistants();
    }
    this.getDefaultIssues();

    if (!this.state.selectedVertical) {
      this.openSearchOverlay();
    }
  }

  componentDidUpdate = (prevProps) => {
    // if (
    //   prevProps.location.hash === '#profile' &&
    //   this.props.location.hash !== '#profile'
    // ) {
    //   this.closeProfile();
    //   return;
    // }

    const { pathname } = this.props.location;
    const { pathname: prevPathname } = prevProps.location;

    if (pathname !== prevPathname) {
      this.setState((prev) => ({
        userConcernData: {
          ...prev.userConcernData,
          showConcern: pathname.includes('/issue'),
          currentStep: 1,
        },
      }));
    }

    if (prevProps.hasError !== this.props.hasError) {
      this.setState({
        requestLoading: false,
      });
    }
    this.setPlaceholderForDoctors();
    if (
      this.state.paginatedCall &&
      this.listContainerRef &&
      this.listContainerRef.current &&
      this.state.fetchNext
    ) {
      this.listContainerRef.current.scrollTop += this.state.scrollTopPos;
    }
  };

  componentWillUnmount() {
    sessionStorage.removeItem('consultRelativeId');
  }

  getDefaultIssues() {
    this.setState({ searching: true });
    defaultIssueSearch('treat', this.props.authToken)
      .then((resp) => {
        const {
          verticals,
          relations,
          filters,
          disclaimersAndCheckboxes,
          disclaimerMessage,
        } = resp;
        this.setState({
          defaultIssues: verticals,
          searching: false,
          defaultConfig: resp,
          relations,
          verticals,
          showSearch: resp.allowSearch,
          disclaimersAndCheckboxes,
          disclaimerMessage,
        });
        const { search } = this.props.location;
        const searchParams = new URLSearchParams(search);
        if (searchParams.get('verticalId')) {
          const filtered = verticals.filter(
            (f) => f.verticalId === Number(searchParams.get('verticalId'))
          );
          this.selectVertical(filtered[0]);
        }
        this.filters = filters;
      })
      .catch((err) => {
        console.error(err);
      });
  }

  searchIssues() {
    if (this.state.searchText.trim() === '') {
      this.setState({
        searchResults: [],
        searching: false,
      });
      return;
    }

    this.setState({
      searching: true,
    });

    autoSuggest(
      this.state.searchText,
      'online',
      null,
      null,
      this.props.authToken
    )
      .then((resp) => {
        this.setState({
          searchResults: resp.suggestions,
          searching: false,
        });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  setPlaceholderForDoctors() {
    document.querySelectorAll('.doctor-image').forEach((ele) => {
      setPlaceholderImageForNode(ele);
      ele.classList.remove('.doctor-image');
    });
  }

  getAssistants(params, paginatedCall = false, fetchNext) {
    if (!params) {
      return;
    }
    const { authToken, ssoRelativeId } = this.props;
    const { nextKey, currentLat, currentLong } = this.state;
    if (nextKey && nextKey.length > 0 && paginatedCall) {
      params.next = nextKey;
    }

    this.setState({
      loading: fetchNext ? false : true,
      nextLoading: !!fetchNext,
    });
    const { language, gender, availability } = this.state.filters;
    params.availabilityFilter = availability?.key || null;
    params.f = gender?.key || null;
    params.languageFilter =
      language?.map((l) => l.languageName)?.join(',') || null;
    params.lat = currentLat === -1 ? null : currentLat;
    params.lng = currentLong === -1 ? null : currentLong;
    const relativeId =
      this.state.relativeId ||
      sessionStorage.getItem('consultRelativeId') ||
      ssoRelativeId;
    if (relativeId && Number(relativeId) !== -1) {
      params.relativeId = relativeId;
    }
    searchOnlineDoctors(params, authToken)
      .then((res) => {
        const { specialists, bookingInfo, next } = res;
        if (specialists.length === 0 && !paginatedCall) {
          this.setState({ nextKey: null, loading: false, doctors: [] });
          return;
        }
        let onlineDoctors = specialists.filter((value) => {
          return value.isActive;
        });
        let offlineDoctors = specialists.filter((value) => {
          return !value.isActive;
        });
        this.setState((prev) => {
          return {
            doctors: paginatedCall
              ? [...prev.doctors, ...specialists]
              : specialists,
            onlineDoctors: params.sf
              ? paginatedCall
                ? [...prev.doctors, ...specialists]
                : specialists
              : paginatedCall
                ? [...prev.onlineDoctors, ...onlineDoctors]
                : onlineDoctors,
            offlineDoctors: paginatedCall
              ? [...prev.offlineDoctors, ...offlineDoctors]
              : offlineDoctors,
            loading: false,
            fetchNext: false,
            opdLabel: bookingInfo.opdLabel,
            bookingLabel: bookingInfo.bookingLabel,
            nextKey: next ? next : null,
            nextLoading: false,
            paginatedCall,
          };
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.setState({
          loading: false,
        });
      });
  }

  bookDoctor = (doctor, type) => {
    const { selectedIssues, selectedRelative } = this.state;
    logEvent('Online Consultations Consult Button');

    if (selectedRelative.relativeId === -1 || !this.doctorToBook) {
      // Ask the user to explicitly select the relative before booking
      // store doctor info and type in 'this'
      this.doctorToBook = doctor;
      this.type = type;
      this.showRelatives();
      return;
    }

    const bookDoctor = doctor ? doctor : this.doctorToBook;
    const consultType = type ? type : this.type;

    const consultRequestInfo = {
      selectedIssuesIndex:
        selectedIssues.length > 0 ? selectedIssues : undefined,
      relative: selectedRelative,
    };
    this.fetchSlots(bookDoctor, consultRequestInfo, consultType);
  };

  fetchSlots = async (doctor, consultRequestInfo, consultType) => {
    const { authToken, history } = this.props;
    let gcds = true; // default true

    if (doctor?.nextRosterTimestamp) {
      const nextRosterTimestamp = doctor?.nextRosterTimestamp;
      const doctorAvailabilityDate = new Date(nextRosterTimestamp * 1000);

      let now = new Date();
      let tomorrowsDate = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() + 1
      );
      // if doctor is available before tomorrow, get current day slots else not
      gcds = doctorAvailabilityDate < tomorrowsDate;
    }
    if (
      this.type === 'bn' ||
      (this.type === 'bfl' &&
        this.state.appointmentDetails.date &&
        this.state.appointmentDetails.time)
    ) {
      history.push('/consultation/confirm', {
        doctor: doctor,
        consultRequestInfo: consultRequestInfo,
        assistantBooking: doctor.isAssistant,
        opdLabel: this.state.opdLabel,
        bookingLabel: this.state.bookingLabel,
        type: consultType,
        slots: this.state.slots,
        labOrderId: this.state.labOrderId,
        appointmentDetails: this.state.appointmentDetails,
      });
    } else {
      try {
        const res = await fetchSlots(doctor.doctorId, authToken, gcds);
        this.setState({ slots: res.data }, () => {
          this.setState({
            showCalendar: true,
          });
        });
      } catch (err) {
        console.error('Error in fetching slot details ', err);
      }
    }
  };

  onShowOpd = () => {
    const { history } = this.props;
    history.push('/home/policy-purchased');
  };

  showDoctorProfile(doctorId, isAssistant) {
    this.setState({
      openProfileId: doctorId,
      assistantProfile: isAssistant,
      profileModalVisible: true,
      profileVisible: true,
    });
  }

  closeProfile = () =>
    this.setState({
      openProfileId: null,
      profileVisible: false,
      modalVisible: false,
    });

  onModalExited = () =>
    this.setState({
      modalVisible: false,
    });

  onProfileModalExited = () => {
    this.setState({
      profileModalVisible: false,
    });
    this.props.history.replace('/upsell/teleconsult');
  };

  showRelatives = () => {
    this.setState({
      modalVisible: true,
      relativesSelectionVisible: true,
    });
  };

  hideModal = () => {
    this.setState({
      modalVisible: false,
    });
  };

  giveRelationConsent = () => {
    const { newRelation } = this.state;
    newRelation.consentGiven = true;
    this.setState({
      newRelation,
    });
  };

  selectNewRelationType(relationId) {
    const { newRelation } = this.state;
    newRelation.relationId = relationId;
    this.setState({
      newRelation,
    });
  }

  selectRelative = (relative) => {
    logEvent('Online Consultation Patient Selected', {
      patientId: relative.relativeId,
      patientName: relative.relativeName,
    });
    console.log('selectRelative', relative);
    this.setState(
      {
        selectedRelative: relative,
      },
      () => {
        if (this.doctorToBook) {
          this.bookDoctor(this.doctorToBook, this.type);
        }
      }
    );
    this.hideModal();
  };

  setRelativeDob = (dob) => {
    const { newRelation } = this.state;
    newRelation.relationDob = dob.toISOString().split('T')[0];
    this.setState({
      newRelation,
    });
  };

  openSearchOverlay = () => {
    logEvent('Online Consultations Search Option Clicked');
    const { searchText } = this.state;
    if (!this.state.showSearchOverlay) {
      this.setState({ showSearchOverlay: true });
      if (searchText) {
        this.searchIssues();
      }
    }
  };

  closeSearchOverlay = () => {
    this.setState({ showSearchOverlay: false });
    if (!this.state.selectedVertical) {
      this.props.history.goBack();
    }
    if (document.querySelector('.consultation-input')) {
      document.querySelector('.consultation-input').blur();
    }
  };

  clearSearch = () => {
    const { showSearchOverlay, selectedVertical } = this.state;
    this.setState({ searchText: '' });
    this.props.dispatch(setSearchText(''));
    if (!showSearchOverlay && selectedVertical) {
      this.getAssistants({ v: selectedVertical });
    } else {
      this.setState({
        showSearchOverlay: true,
      });
    }
    this.getDefaultIssues();
    this.setState({ onlineDoctors: [], showSearchOverlay: true });
  };

  fetchMajorConcernIssues = (verticalId) => {
    const { authToken } = this.props;
    getMajorConcernIssues(verticalId, authToken)
      .then((data) => {
        this.setState((prev) => {
          return {
            showSearch: true,
            userConcernData: {
              ...prev.userConcernData,
              issuesData: data.issues,
            },
          };
        });
      })
      .catch((err) => {
        console.error('Error fetching major concern issues:', err);
      });
  };

  selectVertical(vertical) {
    if (
      (vertical.subCategorization === 'true' ||
        vertical.subCategorization === true) &&
      !this.state.userConcernData.concernRecorded
    ) {
      this.fetchMajorConcernIssues(vertical.verticalId);
      this.setState(
        {
          userConcernData: {
            ...DEFAULT_USER_CONCERN_DATA,
            showConcern: true,
            showSearch: false,
            selectedVerticalId: vertical.verticalId,
            selectedVerticalData: vertical,
            currentStep: 1,
            concernHeading:
              `${vertical.verticalName} SPECIALITIES`.toUpperCase(),
          },
        },
        () => {
          this.props.history.push(`/upsell/teleconsult/issue`);
        }
      );
    } else {
      this.setState((prevState) => ({
        showSearchOverlay: false,
        searchText: vertical.verticalName,
        selectedVertical: vertical.verticalId,
        verticalName: vertical.verticalName,
        nextKey: '',
        loading: true,
        userConcernData: {
          ...prevState.userConcernData,
          concernRecorded: false,
        },
      }));
      this.props.dispatch(setSearchText(vertical.verticalName));
      if (document.querySelector('.consultation-input')) {
        document.querySelector('.consultation-input').blur();
      }
      logEvent('Online Consultations Doctor Type Selected', {
        verticalId: vertical.verticalId,
        verticalName: vertical.verticalName,
      });
      if (this.state.labsVerticalSelected) {
        return this.getAssistants({
          sf: this.state.labsVerticalSelected,
          v: vertical.verticalId,
        });
      }
      this.getAssistants({
        v: vertical.verticalId,
      });
    }
  }

  selectIssue(issue) {
    this.setState({
      showSearchOverlay: false,
      searchText: issue.title,
      selectedIssues: [issue.issueId],
    });
    this.props.dispatch(setSearchText(issue.title));
    if (document.querySelector('.consultation-input')) {
      document.querySelector('.consultation-input').blur();
    }
    this.getAssistants({
      i: issue.issueId,
    });
  }

  selectSuggestion(suggestion) {
    switch (suggestion.type) {
      case 'hv':
        this.selectVertical({
          verticalId: suggestion.id,
          verticalName: suggestion.title,
        });
        this.props.dispatch(setSearchText(suggestion.title));
        break;
      case 'sp':
        logEvent('Online Consultations Search Option Clicked');
        this.showDoctorProfile(suggestion.id, suggestion.isAssistant);
        break;
      default:
        break;
    }
  }

  onVerticalListScrolled = (event) => {
    const { showVerticalsLeftScroll, showVerticalsRightScroll } = this.state;
    if (event.target.scrollLeft > 0) {
      !showVerticalsLeftScroll &&
        this.setState({
          showVerticalsLeftScroll: true,
        });
    } else {
      showVerticalsLeftScroll &&
        this.setState({
          showVerticalsLeftScroll: false,
        });
    }
    if (
      event.target.scrollLeft + event.target.clientWidth <
      event.target.scrollWidth
    ) {
      !showVerticalsRightScroll &&
        this.setState({ showVerticalsRightScroll: true });
    } else {
      showVerticalsRightScroll &&
        this.setState({ showVerticalsRightScroll: false });
    }
  };

  smoothScroll(ele, left, reverse) {
    const start = performance.now();
    const duration = 300;
    const startValue = ele.scrollLeft;
    const scrollPerTimestamp = Math.abs(left - startValue) / duration;
    const multiplier = reverse ? 1 : -1;
    const animate = (timestamp) => {
      const progress = timestamp - start;
      ele.scrollTo(startValue + multiplier * scrollPerTimestamp * progress, 0);
      if (progress < duration) {
        requestAnimationFrame(animate);
      }
    };
    requestAnimationFrame(animate);
  }

  scrollVerticalsLeft = () => {
    const { scrollLeft, clientWidth } = this.verticalScrollContainerRef.current;
    if (scrollLeft === 0) {
      return;
    }
    if (scrollLeft < clientWidth / 2) {
      this.smoothScroll(this.verticalScrollContainerRef.current, 0);
      return;
    }
    this.smoothScroll(
      this.verticalScrollContainerRef.current,
      scrollLeft - clientWidth / 2
    );
  };

  scrollVerticalsRight = () => {
    const { scrollLeft, clientWidth, scrollWidth } =
      this.verticalScrollContainerRef.current;
    if (scrollLeft + clientWidth >= scrollWidth) {
      return;
    }
    if (scrollWidth - scrollLeft + clientWidth < clientWidth / 2) {
      this.smoothScroll(
        this.verticalScrollContainerRef.current,
        scrollWidth - clientWidth,
        true
      );
      return;
    }
    this.smoothScroll(
      this.verticalScrollContainerRef.current,
      scrollLeft + clientWidth / 2,
      true
    );
  };

  selectMajorIssue = (ele) => {
    // const { id: issueId, verticalId } = ele;
    // const { authToken } = this.props;
    // getMinorConcernIssues(verticalId, issueId, authToken)
    //   .then(data => {
    //     this.setState(prev => {
    //       return {
    //         showSearch: true,
    //         userConcernData: {
    //           ...prev.userConcernData,
    //           subIssuesData: data.subIssues,
    //           issueDoctorCount: data.doctorsCount
    //         }
    //       }
    //     })
    //   })
    this.setState(
      (prev) => {
        return {
          userConcernData: {
            ...prev.userConcernData,
            // currentStep: 2,
            selectedIssueId: ele.id,
            selectedIssue: ele,
            concernRecorded: true,
          },
        };
      },
      () => {
        try {
          const { authToken } = this.props;
          const { selectedVerticalId, selectedIssueId, selectedVerticalData } =
            this.state.userConcernData;
          logHealthConcernIssues(
            authToken,
            selectedVerticalId,
            selectedIssueId
          );
          this.selectVertical(selectedVerticalData);
          this.props.history.push(`/upsell/teleconsult`);
          this.props.history.goBack();
        } catch (error) {
          console.error('Error logging health concern issues:', error);
        }
      }
    );
  };

  handleSubIssueSelection = (subIssueId, majorIssueId) => {
    if (majorIssueId) {
      return this.setState((prev) => {
        return {
          userConcernData: {
            ...prev.userConcernData,
            otherInputId: prev.userConcernData.otherInputId
              ? ''
              : `${subIssueId}_${majorIssueId}`,
            otherDescription: prev.userConcernData.otherInputId
              ? ''
              : prev.userConcernData.otherDescription,
          },
        };
      });
    }

    const currentIndex =
      this.state.userConcernData.selectedSubIssueId.indexOf(subIssueId);
    const { selectedSubIssueId } = this.state.userConcernData;
    if (currentIndex === -1) {
      selectedSubIssueId.push(subIssueId);
    } else {
      selectedSubIssueId.splice(currentIndex, 1);
    }

    this.setState((prev) => {
      return {
        userConcernData: {
          ...prev.userConcernData,
          selectedSubIssueId,
        },
      };
    });
  };

  handleOtherTextChange = (text) => {
    this.setState((prev) => {
      return {
        userConcernData: {
          ...prev.userConcernData,
          otherDescription: text,
        },
      };
    });
  };

  submitUserConcern = () => {
    this.setState((prev) => {
      return {
        userConcernData: {
          ...prev.userConcernData,
          isSubmitting: true,
        },
      };
    });

    const { authToken } = this.props;
    const {
      selectedVerticalId,
      selectedIssueId,
      selectedSubIssueId,
      otherDescription,
      selectedVerticalData,
    } = this.state.userConcernData;
    logHealthConcernIssues(
      authToken,
      selectedVerticalId,
      selectedIssueId,
      selectedSubIssueId,
      otherDescription
    )
      .then(() => {
        this.setState(
          (prevState) => ({
            userConcernData: {
              ...prevState.userConcernData,
              concernRecorded: true,
            },
          }),
          () => {
            this.selectVertical(selectedVerticalData);
          }
        );
      })
      .catch((err) => {
        console.error(err);
      });
  };

  renderConcernOptions = () => {
    const { userConcernData } = this.state;

    if (userConcernData.currentStep === 1) {
      // render initial issues list
      if (
        Array.isArray(userConcernData.issuesData) &&
        userConcernData.issuesData.length
      ) {
        return userConcernData.issuesData.map((ele) => {
          return (
            <IssueContainer
              key={ele.id}
              onTap={() => this.selectMajorIssue(ele)}
            >
              <IssueSuggestionIcon src={ele.logoUrl} />
              <IssueTextContainer>
                {ele.issueName && (
                  <div className="txt-black-600-14">{ele.issueName}</div>
                )}
              </IssueTextContainer>
            </IssueContainer>
          );
        });
      } else {
        return <LoadingComponent />;
      }
    } else if (userConcernData.currentStep === 2) {
      // render sub issues list
      if (
        Array.isArray(userConcernData.subIssuesData) &&
        userConcernData.subIssuesData.length
      ) {
        const { majorIssueId, verticalId } = userConcernData.subIssuesData[0];
        return (
          <>
            <IssueTitleContainer>
              <IssueTitle>
                <IssueIconLarge
                  src={this.state.userConcernData.selectedIssue.logoUrl}
                />
                <IssueData>
                  <div
                    style={{
                      color: 'white',
                      fontWeight: '600',
                      fontSize: '15px',
                    }}
                  >
                    {this.state.userConcernData.selectedIssue.issueName}
                  </div>
                  <div>
                    {this.state.userConcernData.issueDoctorCount}+{' '}
                    {
                      this.state.userConcernData.selectedVerticalData
                        .verticalName
                    }{' '}
                    Available
                  </div>
                  <div>Specialized expert for your concern</div>
                </IssueData>
              </IssueTitle>
            </IssueTitleContainer>
            {userConcernData.subIssuesData.map((ele) => {
              return (
                <SubIssueContainer
                  onTap={() => this.handleSubIssueSelection(ele.id)}
                  key={ele.id}
                >
                  <SubIssueTile>
                    <IssueTextContainer>
                      {ele.subIssueName && (
                        <div className="txt-black-400-14">
                          {ele.subIssueName}
                        </div>
                      )}
                    </IssueTextContainer>
                    <SubIssueCheckbox
                      id={`subissue-checkbox-${ele.id}`}
                      type="checkbox"
                      className="checkbox-visit-theme"
                      checked={userConcernData.selectedSubIssueId.includes(
                        ele.id
                      )}
                      onClick={() => {}}
                      onChange={() => {}}
                    />
                    <label htmlFor={`subissue-checkbox-${ele.id}`} />
                  </SubIssueTile>
                </SubIssueContainer>
              );
            })}
            {/* other issue, needed to render manually */}
            <SubIssueContainer
              onTap={() =>
                this.handleSubIssueSelection(verticalId, majorIssueId)
              }
              key={majorIssueId}
            >
              <SubIssueTile>
                <IssueTextContainer>
                  <div className="txt-black-400-14">Others</div>
                </IssueTextContainer>
                <SubIssueCheckbox
                  id={`subissue-checkbox-${majorIssueId}`}
                  type="checkbox"
                  className="checkbox-visit-theme"
                  checked={
                    userConcernData.otherInputId ===
                    `${verticalId}_${majorIssueId}`
                  }
                  onClick={() => {}}
                  onChange={() => {}}
                />
                <label htmlFor={`subissue-checkbox-${majorIssueId}`} />
              </SubIssueTile>
            </SubIssueContainer>

            {userConcernData.otherInputId ===
            `${verticalId}_${majorIssueId}` ? (
              <SubIssueTextArea
                value={this.state.userConcernData.otherDescription}
                onChange={(e) => this.handleOtherTextChange(e.target.value)}
                rows={3}
                placeholder="Other Concern"
              />
            ) : (
              <></>
            )}

            <PrimaryButtonPadded
              // disabled={!this.state.userConcernData.selectedSubIssueId.length}
              loading={this.state.userConcernData.isSubmitting}
              onTap={this.submitUserConcern}
              disabled={
                (userConcernData.otherInputId ===
                  `${verticalId}_${majorIssueId}` &&
                  !userConcernData.otherDescription) ||
                !userConcernData.selectedSubIssueId.length
              }
            >
              <ButtonText>Submit</ButtonText>
            </PrimaryButtonPadded>
          </>
        );
      } else {
        return <LoadingComponent />;
      }
    }

    return <></>;
  };

  openFilterModal = () =>
    this.setState({
      filterModal: true,
    });

  closeFilterModal = () =>
    this.setState({
      filterModal: false,
    });

  onFilterModalExited = () => {
    this.setState({
      filterModal: false,
    });
  };
  handleOutsideClick = (e) => {
    // ignore clicks on the component itself
    if (
      (this.node && this.node.contains(e.target)) ||
      (this.node2 && this.node2.contains(e.target))
    ) {
      return;
    }
    this.closeFilterModal();
  };
  onDateSelection = (date) => {
    this.setState(
      (prev) => ({
        appointmentDetails: {
          ...prev.appointmentDetails,
          date: date
            .toLocaleDateString('fr-CA', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
            })
            .toString(),
        },
        showCalendar: false,
        showSlots: true,
      }),
      () => {
        this.state.slots
          .filter((s) => s.date === this.state.appointmentDetails.date)
          .map((t) => {
            let morningSlot = [];
            let afternoonSlot = [];
            let eveningSlot = [];
            if (t.slots) {
              morningSlot = t.slots.filter(
                (slot) => Number(slot.substring(0, 2)) < 12
              );
              afternoonSlot = t.slots.filter(
                (slot) =>
                  Number(slot.substring(0, 2)) >= 12 &&
                  Number(slot.substring(0, 2)) <= 16
              );
              eveningSlot = t.slots.filter(
                (slot) => Number(slot.substring(0, 2)) > 16
              );
              this.setState({
                morningSlot,
                afternoonSlot,
                eveningSlot,
              });
              if (morningSlot.length > 0) this.setState({ activeSlotType: 1 });
              else if (afternoonSlot.length > 0)
                this.setState({ activeSlotType: 2 });
              else if (eveningSlot.length > 0)
                this.setState({ activeSlotType: 3 });
            }
          });
      }
    );
  };

  selectSlot = () => {
    this.setState({ showSlots: false });
    this.bookDoctor(this.doctorToBook, this.type);
  };

  applyFilter = (language, gender, availability) => {
    this.setState(
      {
        filterModal: false,
        filterPresent: language.length || gender || availability ? true : false,
        filters: {
          language: language || [],
          gender: gender || null,
          availability: availability || null,
        },
      },
      () => {
        this.getAssistants({ v: this.state.selectedVertical });
      }
    );
  };
  fetchLocation(data) {
    // Only proceed if data is present or local state is not set yet
    // prevent multiple state updates
    if (!data) return;
    const { loading, location, failed } = data;
    if (failed) {
      this.setState({
        locationFailed: true,
        locationLoading: false,
      });
      return;
    }
    if (!loading) {
      const { lat, long } = location;
      this.setState({
        currentLat: lat,
        currentLong: long,
      });
    }
  }
  closeView = () => {
    if (this.props.magicBasedLogin) {
      if (typeof window.Android !== 'undefined') {
        window.Android.closeView();
        window.Android.closeView(true);
      } else if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            method: 'closeView',
          })
        );
      } else if (window.webkit && window.webkit.messageHandlers.visitIosView) {
        window.webkit.messageHandlers.visitIosView.postMessage(
          JSON.stringify({
            method: 'closeView',
          })
        );
      } else {
        this.props.history.goBack();
      }
    } else {
      this.props.history.goBack();
    }
  };
  render() {
    const {
      profileVisible,
      openProfileId,
      assistantProfile,
      profileModalVisible,
      modalVisible,
      selectedRelative,
      showSearchOverlay,
      opdLabel,
      bookingLabel,
      searchText,
      showSearch,
      filterModal,
      showCalendar,
      showSlots,
      appointmentDetails,
      slots,
      filterPresent,
      searching,
      searchResults,
      selectedVertical,
      requestLoading,
      loading,
      onlineDoctors,
      offlineDoctors,
      labsFlow,
      doctors,
      disclaimersAndCheckboxes,
      disclaimerMessage,
      activeSlotType,
      morningSlot,
      afternoonSlot,
      eveningSlot,
      nextLoading,
      userConcernData,
      defaultIssues,
      currentLat,
      currentLong,
    } = this.state;

    const { history } = this.props;
    const searchTextLink = Link.state(this, 'searchText').onChange((val) => {
      if (val.length >= 3) {
        this.debounceSearch(val);
        this.setState({ searching: true });
      }
      this.props.dispatch(setSearchText(val));
    });

    const renderDoctor = (ele, idx, laterFlag) => (
      <DoctorSelectCardNew
        key={idx}
        onTap={() => this.showDoctorProfile(ele.doctorId, ele.isAssistant)}
        doctorPicture={ele.profileImg}
        doctorRating={ele.ratings}
        doctorName={ele.doctorName}
        doctorQualifications={ele.vertical}
        doctorExperience={ele.experience}
        orgName={ele.orgName}
        responseTimeText={ele.responseTimeText}
        doctorBadge={ele.orgImg}
        degree={ele.degrees}
        basePrice={ele.baseFee}
        feesLabel={ele.feeLabel}
        doctorPrice={ele.finalFee}
        opdLabel={opdLabel}
        bookingLabel={ele.isActive ? bookingLabel : null}
        onBook={(type) => this.bookDoctor(ele, type)}
        onOpd={this.onShowOpd}
        orgImg={ele.orgImg}
        sponsor={ele.sponsor}
        sponsorLogo={ele.sponsorLogo}
        discountLabel={ele.discountText}
        knownLanguages={ele.knownLanguages}
        isActive={ele.isActive}
      />
    );

    const renderSuggestions = (ele) => (
      <IssueContainer key={ele.id} onTap={() => this.selectSuggestion(ele)}>
        <IssueIcon src={ele.icon} />
        <IssueTextContainer>
          <SearchText>{ele.title}</SearchText>
          {ele.label && <IssueSubText>{ele.label}</IssueSubText>}
        </IssueTextContainer>
      </IssueContainer>
    );

    const renderDefaultIssues = (ele, idx) => {
      return (
        <IssueContainer
          key={ele.verticalId}
          onTap={() => this.selectVertical(ele)}
        >
          <SuggestionIcon src={ele.iconUrl} />
          <IssueTextContainer>
            {ele.verticalName && (
              <div className="txt-black-600-14">{ele.verticalName}</div>
            )}
          </IssueTextContainer>
        </IssueContainer>
      );
    };
    const SLOTS_TAB = [
      { label: 'Morning', value: 1, icon: morningIcon, slots: morningSlot },
      {
        label: 'Afternoon',
        value: 2,
        icon: afternoonIcon,
        slots: afternoonSlot,
      },
      { label: 'Evening', value: 3, icon: eveningIcon, slots: eveningSlot },
    ];

    const SlotsTabs = (props) => (
      <div className="flex flex-row items-center  bg-primary-light rounded-8 p-2">
        {SLOTS_TAB.map((t, index) => {
          if (t.slots.length === 0) return null;
          return (
            <div
              className={`flex flex-row items-center cursor-pointer ${
                activeSlotType === t.value && 'bg-textbox'
              }  rounded-8 px-4 py-2`}
              onClick={() => this.setState({ activeSlotType: t.value })}
            >
              <img src={t.icon} alt="morning" />
              <p className="ml-4px text-body-s text-txtlight font-medium">
                {t.label}
              </p>
            </div>
          );
        })}
      </div>
    );

    const ShowSlotSection = ({ slots, value }) => {
      if (value !== activeSlotType) return null;

      if (slots.length === 0)
        return (
          <div className="flex flex-row items-center h-12 justify-center">
            <p className="ml-4px text-body-s text-txtlight font-medium">
              No Slots Available
            </p>
          </div>
        );

      return (
        <div className="flex-row-wrap">
          {slots.map((s, index) => {
            return (
              <div
                className={`slot-time ${
                  appointmentDetails.time === s
                    ? 'selected-slot-time'
                    : 'unselected-slot-time'
                } flex flex-row items-center justify-center cursor-pointer`}
                style={{
                  width: '90px',
                  height: '32px',
                }}
                key={index}
                onClick={() => {
                  this.setState((prev) => ({
                    appointmentDetails: {
                      ...prev.appointmentDetails,
                      time: s,
                    },
                  }));
                }}
              >
                {appointmentDetails.time !== s ? (
                  <span className="txt-600-12">{s}</span>
                ) : (
                  <div className="flex flex-row items-center justify-center">
                    <img src={slotSelected} alt="" />
                    <span className="ml-8px txt-600-12">{s}</span>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      );
    };
    const onScrollHandler = () => {
      if (this.listContainerRef.current) {
        const { scrollTop, scrollHeight, clientHeight } =
          this.listContainerRef.current;
        if (
          scrollTop + clientHeight === scrollHeight ||
          scrollTop + clientHeight === scrollHeight + 0.5
        ) {
          // This will be triggered after hitting the last element.
          if (this.state.nextKey) {
            this.setState({ scrollTopPos: scrollTop, fetchNext: true });
            this.getAssistants({ v: this.state.selectedVertical }, true, true);
          }
        }
      }
    };

    return (
      <OuterContainer>
        {currentLat === -1 ? (
          <LocationFetcherWrapper onFetch={this.fetchLocation} />
        ) : null}
        <HeaderContainer>
          <Header
            noBorder={true}
            title="Online consultation"
            hideBackButton
          ></Header>
          {showSearch && (
            <CSSTransition
              in={showSearchOverlay}
              timeout={100}
              classNames="expand"
            >
              <SearchContainer>
                <SearchBoxContainer>
                  <svg
                    width="18"
                    height="19"
                    viewBox="0 0 18 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <ellipse
                      cx="8.80589"
                      cy="8.80541"
                      rx="7.49047"
                      ry="7.49047"
                      stroke="#A5A6BB"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M14.0156 14.4043L16.9523 17.3334"
                      stroke="#A5A6BB"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <StyledInputBox
                    valueLink={searchTextLink}
                    className={`consultation-input`}
                    placeholder="Search doctors or specialists"
                    onClick={this.openSearchOverlay}
                    style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#0F0B28',
                    }}
                  />
                  {searchText.trim().length !== 0 && (
                    <CrossIconContainer onTap={this.clearSearch}>
                      <img src={crossIcon} alt="cross" />
                    </CrossIconContainer>
                  )}
                </SearchBoxContainer>
                {selectedVertical && (
                  <FilterButton onTap={this.openFilterModal}>
                    {filterPresent && <RedDot />}
                    <img src={filterIcon} alt="filter" />
                  </FilterButton>
                )}
              </SearchContainer>
            </CSSTransition>
          )}
        </HeaderContainer>
        <BodyContainer>
          <>
            {(searchText !== '' || labsFlow !== '') && (
              <>
                {requestLoading || loading ? (
                  <LoadingComponent />
                ) : doctors.length === 0 ? (
                  <EmptyContainer>
                    <div
                      style={{
                        backgroundImage: `url(${errorModalBg})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: '114px 114px',
                        backgroundPosition: 'center center',
                        textAlign: 'center',
                      }}
                    >
                      <EmptyIcon
                        src={errorModalIcon}
                        style={{ width: '164px', height: '116px' }}
                      />
                    </div>
                    <EmptyText>
                      Sorry, we could not find any doctors in the selected
                      vertical. Please try selecting another vertical or try
                      contacting the customer care.
                    </EmptyText>
                  </EmptyContainer>
                ) : (
                  <DoctorsListContainer
                    onScroll={onScrollHandler}
                    ref={this.listContainerRef}
                  >
                    {onlineDoctors.length > 0 &&
                      (!!searchText.length || !!labsFlow.length) && (
                        <>
                          <span
                            style={{
                              margin: '20px 20px 0px 20px',
                              fontSize: '14px',
                              fontWeight: '600',
                            }}
                          >
                            Available Now
                          </span>
                          <div className="p-20px pb-0">
                            {onlineDoctors.map(renderDoctor)}
                          </div>
                          {nextLoading && this.state.nextKey && (
                            <div className="p-20px w-full">
                              <div className="h-10 flex w-full justify-center">
                                <LoadingComponent></LoadingComponent>
                              </div>
                            </div>
                          )}
                        </>
                      )}
                    {offlineDoctors.length > 0 && !!searchText.length && (
                      <>
                        <span
                          style={{
                            margin: '0px 20px 0px 20px',
                            fontSize: '14px',
                            fontWeight: '600',
                          }}
                        >
                          Available Later
                        </span>
                        <div className="p-20px pb-0">
                          {offlineDoctors.map(renderDoctor)}
                        </div>
                        {nextLoading && this.state.nextKey && (
                          <div className="p-20px w-full">
                            <div className=" h-10 flex w-full justify-center">
                              <LoadingComponent></LoadingComponent>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </DoctorsListContainer>
                )}
              </>
            )}
            <FadeTransition
              in={showSearchOverlay && labsFlow === ''}
              mountOnEnter
              unmountOnExit
              timeout={300}
            >
              <SearchBodyContainer>
                {searchText === '' &&
                  labsFlow === '' &&
                  (!userConcernData.showConcern ? (
                    <>
                      <p className="mx-20px my-12px text-body-l font-semibold text-textHeader">
                        COMMON SPECIALISTS
                      </p>
                      {defaultIssues.map(renderDefaultIssues)}
                    </>
                  ) : (
                    <>
                      <ConcernText className="mx-20px my-12px text-body-l font-semibold text-textHeader">
                        Help us get you the best assistance <br />
                        Please specify your issue:
                        {/* {this.state.userConcernData.currentStep === 1 ? this.state.userConcernData.concernHeading : 'PLEASE SELECT YOUR CONCERNS:'} */}
                      </ConcernText>
                      {this.renderConcernOptions()}
                    </>
                  ))}
                {searchResults.length > 0 && searchText.length !== '' && (
                  <>
                    <SearchResultText>Related Searches</SearchResultText>
                    <IssueGroupContainer>
                      {searchResults.map(renderSuggestions)}
                    </IssueGroupContainer>
                  </>
                )}
                {searchText.length > 0 &&
                  !searching &&
                  searchResults.length === 0 &&
                  !loading && (
                    <div
                      className="flex flex-col h-full w-full items-center pt-52px  text-secondaryText mx-auto"
                      style={{ width: '300px' }}
                    >
                      <Player
                        autoplay
                        loop
                        src="https://assets9.lottiefiles.com/packages/lf20_ntbn1esl.json"
                        style={{ height: '300px', width: '300px' }}
                      ></Player>
                      <p className=" text-primary font-bold text-title-m">
                        Oops! We could't find anything
                      </p>
                      <p className="text-title-s font-semibold text-center mt-16">
                        Apologies, but we were unable to locate any doctors that
                        match your selected filers.
                      </p>
                    </div>
                  )}
                {searching && <LoadingComponent />}
              </SearchBodyContainer>
            </FadeTransition>
          </>
        </BodyContainer>
        {profileModalVisible && (
          <Modal>
            <ModalContainer onClick={this.closeProfile}>
              <div className="doctorProfileModal">
                <FlyInTransition
                  in={profileVisible}
                  mountOnEnter
                  unmounOnExit
                  onExited={this.onProfileModalExited}
                  appear
                  classNames="slide-in"
                >
                  <DoctorProfileNew
                    doctorId={openProfileId}
                    assistantDoctor={assistantProfile}
                    closeProfile={this.closeProfile}
                    footer={true}
                    relativeId={this.state.relativeId}
                  />
                </FlyInTransition>
              </div>
            </ModalContainer>
          </Modal>
        )}
        {modalVisible && (
          <PatientModal
            hideModal={this.hideModal}
            serviceLine={SERVICE_LINE_NAMES.TELE}
            selectPatient={this.selectRelative}
            selectedPatient={this.state.selectedRelative}
            getPatient={
              clientConfig.useDopeRelatives
                ? () => getAllDopeRelatives(this.props.authToken)
                : undefined
            }
            disclaimersAndCheckboxes={disclaimersAndCheckboxes}
            disclaimerMessage={disclaimerMessage}
            selectedVertical={selectedVertical}
          />
        )}

        {filterModal && (
          <DoctorFilterModal
            filterModal={filterModal}
            hideModal={this.closeFilterModal}
            selectedVerticalId={selectedVertical}
            onApplyFilter={this.applyFilter}
            appliedFilters={this.state.filters}
          />
        )}
        {showCalendar && (
          <CalendarModal
            hideModal={() => {
              appointmentDetails.date
                ? this.setState({ showCalendar: false })
                : this.setState({
                    showCalendar: false,
                    selectedAppointmentTime: 'now',
                  });
              this.type = null;
              this.doctorToBook = null;
              this.setState({
                selectedRelative: {
                  relativeId: -1,
                  relativeRelation: null,
                  relativeIcon: null,
                },
              });
            }}
            onDateSelection={this.onDateSelection}
            selectedDate={(date) =>
              this.setState((prev) => ({
                appointmentDetails: { ...prev.appointmentDetails, date: date },
              }))
            }
            slots={slots}
          />
        )}
        {showSlots && (
          <Modal>
            <div
              className="modalContainer"
              onClick={(e) => {
                // ignore clicks on the component itself
                if (this.node && this.node.contains(e.target)) {
                  return;
                }
                if (appointmentDetails.time)
                  this.setState({ showSlots: false });
                else
                  this.setState({
                    showSlots: false,
                    selectedAppointmentTime: 'now',
                  });
              }}
            >
              <FlyInTransition
                in={showSlots}
                mountOnEnter
                unmountOnExit
                onExited={() => this.setState({ showSlots: false })}
                appear
              >
                <div
                  className="modalBody absolute"
                  ref={(node) => (this.node = node)}
                  style={{ minHeight: '500px' }}
                >
                  <div className="modalHeader">
                    <div className="flex flex-row items-center">
                      <img src={slotIcon} alt="" />
                      <p className="ml-10px text-body-l text-txtlight-new font-semibold">
                        Choose Appointment Time
                      </p>
                    </div>
                    <CloseContainer
                      onTap={() => {
                        appointmentDetails.time
                          ? this.setState({ showSlots: false })
                          : this.setState({
                              showSlots: false,
                              selectedAppointmentTime: 'now',
                            });
                        this.type = null;
                        this.doctorToBook = null;
                        this.setState({
                          selectedRelative: {
                            relativeId: -1,
                            relativeRelation: null,
                            relativeIcon: null,
                          },
                        });
                      }}
                    >
                      <CloseIcon />
                    </CloseContainer>
                  </div>
                  <div className=" slots p-4 overflow-auto h-96 pb-16 mx-auto flex flex-col items-center">
                    <SlotsTabs />
                    {SLOTS_TAB.map((t, index) => (
                      <ShowSlotSection
                        key={index}
                        value={t.value}
                        slots={t.slots}
                      />
                    ))}
                  </div>
                  <div className="w-full flex flex-row justify-center items-center absolute bottom-0 z-10 bg-textbox border border-txtlight-shades4 p-4 pb-6">
                    <PrimaryButton
                      className=" mt-10 w-full"
                      disabled={appointmentDetails.time === ''}
                      onTap={this.selectSlot}
                    >
                      <div
                        className=" text-body-l text-textbox font-semibold "
                        style={{ textAlign: 'center' }}
                      >
                        Confirm
                      </div>
                    </PrimaryButton>
                  </div>
                </div>
              </FlyInTransition>
            </div>
          </Modal>
        )}
      </OuterContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  userId: state.user.userId,
  authToken: state.user.authToken,
  hasError: state.app.appError.hasError,
  sponsorId: state.user.sponsorId,
  user: state.user,
  searchText: state.user.searchText,
  magicBasedLogin: state.app.magicBasedLogin,
  ssoRelativeId: state.user.relativeId,
});

export default connect(mapStateToProps)(DoctorListContainer);
